import { logRenderingError } from '@nbx/log-rendering-error';
import React, { Suspense } from 'react';
import ErrorPage from 'components/app/ErrorPage';
import App from './App';

export default class MainRoot extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    logRenderingError(error, info);
  }

  render() {
    return (
      <Suspense fallback={React.Fragment}>
        {this.state.hasError ? <ErrorPage clearError={() => this.setState({ hasError: false })} /> : <App />}
      </Suspense>
    );
  }
}
